module.exports = __webpack_public_path__ + "img/icon_benefit1@3x.3023d1d5.png";